import { DataLayerEventName } from '../helpers/DataLayerEventName'
import { SSWTransaction } from '../ssw'
import { BreachScreenType } from './breach-event-types'
import { ComponentEvent } from './component-event'

export interface SubscribeEventProps {
    /* What paywall method was implemented ie freemium vs metered */
    paywallType: 'freemium'
    /* lead in depth - how many paragraphs were shown in the lead in */
    leadDepth: number
    /* creative name */
    creative: undefined
    breachScreenType: undefined
    popupMethod: undefined
    deal: undefined
    upcomingNotify?: number
    /* Subscription price point */
    pricepoint: number[]
}

export interface ViewSubscriptionItem {
    /** Index of the item in the list */
    index: number
    /** Package name: Everyday Digital, Weekend Papers + Everyday Digital, etc. */
    item_name: string
    /** Rate code */
    item_id: string
    component_path: string
    /** Site name */
    item_brand: string
    /** paywall method - freemium|metered */
    item_list_category: string
    /** Premium - Inline */
    item_list_category2: string
    /** TW_Article_Breach_WestBlue_Design_PhotoPackages, etc. */
    item_list_name: string
    /**  weekly original price*4 */
    price: number
    quantity: number
    currency: 'AUD'
}

type SubscribeCompleteEventProps = SubscribeEventProps & SSWTransaction

export interface SubscribeClickEvent
    extends ComponentEvent<SubscribeEventProps> {
    type: DataLayerEventName.subscribeClick
}

export interface SubscribeCompleteEvent
    extends ComponentEvent<SubscribeCompleteEventProps> {
    type: DataLayerEventName.subscribeComplete
}

// GA4 add_to_cart event
export interface AddToCartEvent
    extends ComponentEvent<Record<string, unknown>> {
    type: DataLayerEventName.addToCart
    payload: {
        currency: 'AUD'
        /** Rate code */
        item_id: string
        /** Site name */
        item_brand: string
        /** package name: Everyday Digital, Weekend Papers + Everyday Digital, etc. */
        item_name: string
        /** weekly original price*4 weeks */
        price: number
        quantity: number
        /** Offer code */
        coupon?: string
        /** Amount of discount*4 weeks */
        discount: number
        item_variant: 'native' | 'swg'
        breachScreenType?: BreachScreenType
    }
}

// GA4 view_item_list event - subscription package items
export interface ViewSubscriptionItemListEvent
    extends ComponentEvent<Record<string, unknown> | any[]> {
    type: DataLayerEventName.viewSubscriptionItemListEvent
    parentType: DataLayerEventName.viewItemListEvent
    payload: {
        items: ViewSubscriptionItem[]
        breachScreenType?: BreachScreenType
    }
}

interface Transaction {
    sku: string
    name: string
    price: number
    quantity: 1
}

interface SubscribeBaseGTMProps
    extends Omit<SubscribeEventProps, 'pricepoint'> {
    transactionAffiliation: 'The West'
    pricepoint: string
}

interface SubscribeCompleteGTMProps
    extends SubscribeBaseGTMProps,
        Omit<SSWTransaction, 'productSku' | 'productName'> {
    transactionProducts: Transaction[]
    transactionShipping: 0
    transactionAffiliation: 'The West'
    pricepoint: string
}

export type SubscribeEvent = SubscribeClickEvent | SubscribeCompleteEvent

export function toSubscribeBaseEventShape(
    props: SubscribeEventProps,
): SubscribeBaseGTMProps {
    return {
        ...props,
        transactionAffiliation: 'The West',
        pricepoint: props.pricepoint.join(','),
    }
}

export function toSubscribeCompleteEventShape(
    props: SubscribeCompleteEventProps,
): SubscribeCompleteGTMProps {
    const {
        transactionId,
        transactionTotal,
        transactionTax,
        productSku,
        productName,
        pricepoint,
        ...subscribeProps
    } = props

    return {
        ...subscribeProps,
        transactionId,
        pricepoint: pricepoint.join(','),
        transactionAffiliation: 'The West',
        transactionTotal,
        transactionTax,
        transactionShipping: 0,
        transactionProducts: [
            {
                sku: productSku,
                name: productName,
                price: transactionTotal,
                quantity: 1,
            },
        ],
    }
}
